import { apiClient } from "@/lib/api";
import type {
  RunOptimizationPayload,
  RunOptimizationResponse,
} from "@/types/routes";

/**
 * Triggers async route optimization via OR-Tools solver.
 * POST /api/v1/planning/run/
 *
 * The response contains a Celery task_id. Poll
 * GET /api/v1/planning/result/{task_id}/ to check completion.
 */
export async function runOptimization(
  payload: RunOptimizationPayload,
): Promise<RunOptimizationResponse> {
  const { data } = await apiClient.post<RunOptimizationResponse>(
    "/v1/planning/run/",
    payload,
  );
  return data;
}

export interface ActiveBatchResponse {
  batch_id: string | null;
  done: number;
  total: number;
}

/** GET /api/v1/planning/active-batch/ — returns current batch progress or null if idle */
export async function fetchActiveBatch(): Promise<ActiveBatchResponse> {
  const { data } = await apiClient.get<ActiveBatchResponse>(
    "/v1/planning/active-batch/",
  );
  return data;
}
